module.exports = __webpack_public_path__ + "img/photo-0109.8b014925.jpg";